/* tslint:disable */
/* eslint-disable */
/**
 * Berichtsmanagement-common
 * Berichte verwalten
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  MaschinenGruppe,
} from '../models/index';
import {
    MaschinenGruppeFromJSON,
    MaschinenGruppeToJSON,
} from '../models/index';

export interface MaschinengruppenRequest {
    jahr?: number;
}

/**
 * CommonApi - interface
 * 
 * @export
 * @interface CommonApiInterface
 */
export interface CommonApiInterface {
    /**
     * Gibt eine Liste aller Maschinengruppen zurück.
     * @summary Gibt eine Liste aller Maschinengruppen zurück.
     * @param {number} [jahr] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommonApiInterface
     */
    maschinengruppenRaw(requestParameters: MaschinengruppenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<MaschinenGruppe>>>;

    /**
     * Gibt eine Liste aller Maschinengruppen zurück.
     * Gibt eine Liste aller Maschinengruppen zurück.
     */
    maschinengruppen(requestParameters: MaschinengruppenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<MaschinenGruppe>>;

}

/**
 * 
 */
export class CommonApi extends runtime.BaseAPI implements CommonApiInterface {

    /**
     * Gibt eine Liste aller Maschinengruppen zurück.
     * Gibt eine Liste aller Maschinengruppen zurück.
     */
    async maschinengruppenRaw(requestParameters: MaschinengruppenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<MaschinenGruppe>>> {
        const queryParameters: any = {};

        if (requestParameters.jahr !== undefined) {
            queryParameters['jahr'] = requestParameters.jahr;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_auth", []);
        }

        const response = await this.request({
            path: `/api/v1/machinegroups`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MaschinenGruppeFromJSON));
    }

    /**
     * Gibt eine Liste aller Maschinengruppen zurück.
     * Gibt eine Liste aller Maschinengruppen zurück.
     */
    async maschinengruppen(requestParameters: MaschinengruppenRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<MaschinenGruppe>> {
        const response = await this.maschinengruppenRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
